import { render } from "./Account.vue?vue&type=template&id=7ea13d9c"
const script = {}

import exportComponent from "/home/gitlab-runner/builds/gyEBPJq1/0/curvesdev/skolkovo-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__